<template>
<div class="columns is-multiline">
    <div class="column is-6">
        <div class="field">
            <input type="text" v-model="dbHost" @keyup.enter="storeDatabase" :class="{ 'is-danger': hasError('db_host') }" class="input custom-input-size is-medium" placeholder="Database host" autocomplete="off"/>
            <span v-if="hasError('db_host')" class="help is-danger">{{ getError('db_host') }}</span>
        </div>
    </div>
    <div class="column is-6">
        <div class="field">
            <input type="text" v-model="dbPort" @keyup.enter="storeDatabase" :class="{ 'is-danger': hasError('db_port') }" class="input custom-input-size is-medium" placeholder="Database port" autocomplete="off"/>
            <span v-if="hasError('db_port')" class="help is-danger">{{ getError('db_port') }}</span>
        </div>
    </div>
    <div class="column is-6">
        <div class="field">
            <input type="text" v-model="dbName" @keyup.enter="storeDatabase" :class="{ 'is-danger': hasError('db_name') }" class="input custom-input-size is-medium" placeholder="Database name" autocomplete="off"/>
            <span v-if="hasError('db_name')" class="help is-danger">{{ getError('db_name') }}</span>
        </div>
    </div>
    <div class="column is-6">
        <div class="field">
            <input type="text" v-model="dbUser" @keyup.enter="storeDatabase" :class="{ 'is-danger': hasError('db_user') }" class="input custom-input-size is-medium" placeholder="Database user" autocomplete="off"/>
            <span v-if="hasError('db_user')" class="help is-danger">{{ getError('db_user') }}</span>
        </div>
    </div>
    <div class="column is-6">
        <div class="field">
            <input type="password" v-model="dbPassword" @keyup.enter="storeDatabase" :class="{ 'is-danger': hasError('db_password') }" class="input custom-input-size is-medium" placeholder="Database password" autocomplete="off"/>
            <span v-if="hasError('db_password')" class="help is-danger">{{ getError('db_password') }}</span>
        </div>
    </div>
    <div class="column is-6">
        <div class="field">
            <input type="password" v-model="dbPasswordConfirmation" @keyup.enter="storeDatabase" :class="{ 'is-danger': hasError('db_password_confirmation') }" class="input custom-input-size is-medium" placeholder="Database password confirmation" autocomplete="off"/>
            <span v-if="hasError('db_password_confirmation')" class="help is-danger">{{ getError('db_password_confirmation') }}</span>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';
import FormErrorsMixin from '@/mixins/FormErrors';

export default {
    mixins: [FormErrorsMixin],

    data() {
        return {
            dbHost: '',
            dbPort: 5432,
            dbName: '',
            dbUser: '',
            dbPassword: '',
            dbPasswordConfirmation: '',
            allowedInputs: ['db_host', 'db_port', 'db_name', 'db_user', 'db_password', 'db_password_confirmation'],
            error: '',
        }
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        storeDatabase() {
            Api().post('databases/postgresql', this.postgreSQLData)
                .then(response => {
                    Event.$emit('refreshDatabaseStats', 'postgresql');
                    Event.$emit('refreshDatabases', 'postgresql', () => {
                        swal('Success!', 'The database was added.', 'success');
                        Event.$emit('closeAddDatabase');
                    });
                })
                .catch(error => {
                    if (!this.storeErrors(error.response.data.errors)) {
                        if (typeof error.response.data.message == 'string') {
                            this.error = error.response.data.message;
                        } else {
                            this.error = 'Something wrong happened. Refresh the page and try again.';
                        }
                    }
                })
                .finally(() => {
                    this.storingDatabase = false;
                });
        },

        listenEvents() {
            Event.$on('storeDatabase', () => {
                this.storeDatabase();
            });
        },
    },

    computed: {
        postgreSQLData() {
            return {
                db_host: this.dbHost,
                db_port: this.dbPort,
                db_name: this.dbName,
                db_user: this.dbUser,
                db_password: this.dbPassword,
                db_password_confirmation: this.dbPasswordConfirmation,
            }
        },
    },
}
</script>
